import { AbsenceImportWidget } from 'widgets/abcenseImport/ui';
import { useAppDispatch } from 'app/store';
import { useEffect } from 'react';
import { uiModel } from 'entities/ui';
import { useTitle } from '../helpers';

/**
 * @page Absence import page
 */

const AbsenceImportPage = () => {
  useTitle('Импортировать неявки');
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(uiModel.Absence.actions.resetTable());
    },
    [],
  );

  return <AbsenceImportWidget />;
};

export default AbsenceImportPage;
